// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__3tNMx","disabled":"FileBtn_disabled__23RiR","warn":"FileBtn_warn__h46O2","fade":"FileBtn_fade__1Jibm"};